<template>
  <img :src="icon" >
</template>

<script>
export default {
	props: ['icon']
}
</script>

<style scoped>
img {
	object-fit: contain;
}
</style>